import { css, styled } from './theme-provider';
import { YarmillLoader } from './yarmill-loader';

const Layout = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #edf0f5;

  svg {
    width: 250px;
    height: auto;
    max-width: 50vw;
  }

`;

export const LoadingScreenWrapper = styled.div<{
  readonly $showLoader: boolean;
}>`
  position: fixed;
  inset: 0;
  display: flex;
  z-index: 10;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  transition: opacity 500ms ease;
  transition-property: opacity, filter;

  ${({ $showLoader }) =>
    !$showLoader &&
    css`
      opacity: 0;
      filter: blur(20px);
      pointer-events: none;
  `};
`;

export function LoadingScreen() {
  return (
    <Layout>
      <YarmillLoader />
    </Layout>
  );
}
